import { z } from "zod";

export const BranchedQuestionOutputSchema = z.object({
	question: z.number().nullable(),

	answer: z.number().nullable(),

	targetQuestion: z.number().nullable(),

	targetQuestionType: z.enum(["NEXT", "END_OF_FORM", "MULTIPLE"]).nullable()
});

export const BranchedQuestionInputSchema = z.object({
	question: z.number().nullable(),

	answer: z.number().nullable(),

	targetQuestion: z.number().nullable(),

	targetQuestionType: z.enum(["NEXT", "END_OF_FORM", "MULTIPLE"]).nullable()
});

export type BranchedQuestionModel = z.infer<
	typeof BranchedQuestionOutputSchema
>;

export type BranchedQuestionInput = z.infer<typeof BranchedQuestionInputSchema>;
